// extracted by mini-css-extract-plugin
export default {"identityProviderDetailsDropdownMenu":"identity-provider-details-dropdown-menu__identity-provider-details-dropdown-menu__zz8WH"};